import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { invoicingActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { BookingsService } from '../../services/bookings.service';
import { InvoicingState } from './invoicing.state';
import { storeInvoicingKey } from '../reducers';
import { InvoicingStatus } from '../../models/entities/invoice';

@Injectable({
  providedIn: 'root',
})
export class InvoicingEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private bookingsService: BookingsService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        invoicingActions.findAll,
        invoicingActions.setPage,
        invoicingActions.setSearch,
        invoicingActions.setInvoicingStatus,
        invoicingActions.setDatesRange,
        invoicingActions.setOrder,
        invoicingActions.resetFilters,
      ),
      withLatestFrom(this.store$),
      switchMap(([action, store]) => {
        const invoicesState: InvoicingState = store[storeInvoicingKey];

        return this.bookingsService
          .findAllForInvoicing({
            ...invoicesState.filters,
            // @ts-ignore
            order_by: invoicesState.filters.order?.map((orderBy) => [
              orderBy.field,
              orderBy.order,
            ]),
          })
          .pipe(
            map((response) =>
              invoicingActions.findAllSuccess({
                bookings: response.data,
                total: response.total,
              }),
            ),
            catchError((error: ApiError) =>
              of(invoicingActions.findAllError({ error: error.message })),
            ),
          );
      }),
    ),
  );

  findOpenCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invoicingActions.findOpenCount),
      mergeMap(() => {
        return this.bookingsService
          .findAllForInvoicing({
            page: 1,
            invoicing_status: [
              InvoicingStatus.Open,
              InvoicingStatus.Overpaid,
            ].join(','),
            order_by: null,
          })
          .pipe(
            map((response) =>
              invoicingActions.findOpenCountSuccess({
                total: response.total,
              }),
            ),
            catchError((error: ApiError) =>
              of(invoicingActions.findAllError({ error: error.message })),
            ),
          );
      }),
    ),
  );
}
